"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _Treemap = _interopRequireDefault(require("@rsuite/icon-font/lib/charts/Treemap"));

// Generated by script, don't edit it please.
var Treemap = (0, _createSvgIcon["default"])({
  as: _Treemap["default"],
  ariaLabel: 'treemap',
  category: 'charts',
  displayName: 'Treemap'
});
var _default = Treemap;
exports["default"] = _default;
module.exports = exports.default;